@import '~style-sheet-helpers/core.less';

.modal {
  width: 750px;
  height: 660px;
}

.body {
  height: 100%;
  width: 100%;
}

.loading {
  height: 100%;
  width: 100%;
}

.content {
  height: 100%;
  width: 100%;
}

.footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.locked-tab {
  display: flex;
  gap: 8px;
  align-items: center;
}

.lock-icon {
  width: 12px;
}
